import React from 'react'
import ReactDOM from 'react-dom/client'
import '@fontsource-variable/inter'
import App from './App'
import './index.css'
import { ThemeProvider } from './components/ThemeProvider'
import { register as registerServiceWorker } from './lib/serviceWorker'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Failed to find the root element')
}
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)

// Register service worker for offline support
registerServiceWorker({
  onSuccess: () => {
    console.log('✅ App is ready to work offline');
  },
  onUpdate: (_registration) => {
    console.log('🔄 New version available');
    // Force refresh to get latest version
    window.location.reload();
  },
  onError: (error) => {
    console.error('❌ Service worker registration failed:', error);
  }
});

